module.exports = __webpack_public_path__ + "@/assets/img/banner-mp-mobile.8799d14f.jpg";